import { MenuService } from './../services/menu.service';
import { ContractService } from './../interfaces/contract-service.model';
import { LanguageService } from './../services/language.service';
import { Response } from '@angular/http';
import { NotificationsService } from 'angular2-notifications';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, Event as RouterEvent, NavigationEnd } from '@angular/router';
import { Contract } from './../interfaces/contract.model';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from './../services/local-storage.service';
import { BreadcrumbService } from 'ng2-breadcrumb/ng2-breadcrumb';
import { ContractsService } from './../services/contracts.service';

import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { FormService } from '../services/form.service';
import { RodoClientService } from '../services/rodo-client.service';
import { DateService } from '../services/date.service';

@Component({
  selector: 'app-contract-details',
  templateUrl: './contract-details.component.html'
})
export class ContractDetailsComponent implements OnInit {

  public API_URL: any = `${environment.api_url}`;

  public newPosition: any;

  public newCategory: any;

  public contractID: number;

  public contract: Contract;

  public services: Array<ContractService>;

  public contractServicesChilds: Array<ContractService>;

  public changeContractNameForm: FormGroup;

  public showChangeContractName: Boolean = false;

  public contractDetailsLoading: Boolean = true;

  public contractPaymentsStatusColors: any = ['black', 'orange', 'red', 'green', 'black'];

  public newClientRodoForm: FormGroup;

  constructor(
    private contractsService: ContractsService,
    private breadcrumbService: BreadcrumbService,
    private localStorageService: LocalStorageService,
    private notificationsService: NotificationsService,
    private route: ActivatedRoute,
    private languageService: LanguageService,
    private menuService: MenuService,
    private router: Router,
    private formService: FormService,
    private rodoClientService: RodoClientService,
    private dateService: DateService,

  ) {
    let controls = {
      answer: new FormControl(false),
      newGroup: new FormControl(),
      newCategory: new FormControl(),
      newPosition: new FormControl()
    };

    let validators = {
      answer: [Validators.pattern('true')]
    };

    this.newClientRodoForm = this.formService.buildForm(controls, validators);

  }

  showChangeContractNameForm() {
    this.showChangeContractName = true;
    this.changeContractNameForm = new FormGroup({
      contractName: new FormControl(this.contract['name'], [Validators.required])
    });
  }

  changeContractName() {
    this.contractsService.changeContractName(this.localStorageService.get('company'), this.contractID,
      this.changeContractNameForm.controls['contractName'].value).subscribe(
        (response: Contract) => {
          this.contract = response;
          this.showChangeContractName = false;
          this.menuService.getMenuStructure();
        }
      );
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.contractID = params['contract'];
      this.contractsService.getContract(this.localStorageService.get('company'), this.contractID).subscribe(
        (contract: Contract) => {
          this.contract = contract;
          this.contractDetailsLoading = false;
        }
      );

      this.contractsService.getContractServices(this.localStorageService.get('company'), this.contractID).subscribe(
        (contractServices: Array<ContractService>) => {
          this.services = contractServices;
        }
      );
    });
  }

  public newMessage() {
    this.router.navigate(['messages/new'], {
      queryParams: { severity: 2 }
    });
  }

  saveClientRodo(answer, modal) {
    var response = this.rodoClientService.saveClientRodo(answer, this.contractID, modal);
  }

  openTermsModal(modal: any): void {
    modal.open();
    this.newClientRodoForm.controls['answer'].setValue(false);
  }
}




// WEBPACK FOOTER //
// ./src/app/contract/contract-details.component.ts